module.exports = __webpack_public_path__ + "img/waaarp_logo_wh.9ac25b15.png";